import { render, staticRenderFns } from "./ProfilePersonalisation.vue?vue&type=template&id=ef114cfa&"
import script from "./ProfilePersonalisation.vue?vue&type=script&lang=ts&"
export * from "./ProfilePersonalisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports